import { createContext } from 'react'
import { MainLayoutContextProps } from 'Components/Layouts/types'

export const MainLayoutContext = createContext<MainLayoutContextProps>({
})